<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <v-card tile>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" @click.stop="PDF()">Exportar PDF</v-btn>
                <v-spacer></v-spacer>
                <div>
                    <v-btn icon @click="show = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>
            </v-card-actions>
            <div id="pdfpresupuesto">
                <table border="0" width="750">
                    <tr>
                        <td height="2"></td>
                    </tr>
                    <tr>
                        <td><img border="0" src="../../../../public/images/encabezado.jpg" width="750"></td>
                    </tr>
                    <tr>

                        <td height="600"></td>
                    </tr>
                    <tr>
                        <td>
                            <table border="0" width="100%">
                                <tr>
                                    <td rowspan="8" width="300"><img border="0"
                                            src="../../../../public/images/fachada.png">
                                    </td>
                                    <td>
                                        <font face="Calibri" size="2" color="#000000">Cliente: {{ cliente }}</font>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <font face="Calibri" size="2" color="#000000">Dirección: {{ direccion }}</font>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <font face="Calibri" size="2" color="#000000">Tel: {{ tel }}</font>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <font face="Calibri" size="2" color="#000000">At.: {{ contacto }}</font>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <font face="Calibri" size="2" color="#000000">De: {{ respcom }}</font>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <font face="Calibri" size="2" color="#000000">Referencia:{{ referencia }}</font>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <font face="Calibri" size="2" color="#000000">Presupuesto: {{ presupuesto }}
                                        </font>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <font face="Calibri" size="2" color="#000000">Fecha: {{ fecha }}</font>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <div class="html2pdf__page-break"></div>
                    <tr>
                        <td height="2"></td>
                    </tr>
                    <tr>
                        <td><img border="0" src="../../../../public/images/encabezado.jpg" width="750"></td>
                    </tr>
                    <tr>
                        <td style="background: #009366">
                            <p style="margin-top: 0; margin-bottom: 0" align="center">
                                <font face="Calibri" size="2" color="#ffffff"><b>VISIÓN - MISIÓN - VALORES</b></font>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p align="center">
                                <img border="0" src="../../../../public/images/visionmisionvalores.png" width="600">
                            </p>
                        </td>
                    </tr>
                    <div class="html2pdf__page-break"></div>
                    <tr>
                        <td height="2"></td>
                    </tr>
                    <tr>
                        <td><img border="0" src="../../../../public/images/encabezado.jpg" width="750"></td>
                    </tr>
                    <tr>
                        <td style="background: #009366">
                            <p style="margin-top: 0; margin-bottom: 0" align="center">
                                <font face="Calibri" size="2" color="#ffffff"><b>NUESTRA EMPRESA</b></font>
                            </p>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <p style="line-height: 100%">
                                <font face="Calibri" size="2" color="#000000">
                                    A partir de 1998 se crea la empresa <b>ELECTROINGENIERÍA INDUSTRIAL
                                        COMERCIAL Y DE SERVICIOS S.A. (Electroingeniería ICS SA)</b> con la
                                    escisión de Electroingeniería S.A., manteniendo en su totalidad el &quot;know
                                    how&quot;, los antecedentes, los medios de producción, los recursos humanos,
                                    económicos y financieros, y los rubros de actividad desarrollados hasta
                                    esa fecha.</font>
                            </p>
                            <p class="Standard"
                                style="text-align:justify;text-justify:inter-ideograph;line-height: 100%">
                                <font face="Calibri" size="2" color="#000000"><b>Electroingeniería ICS SA</b> desarrolla
                                    operaciones,
                                    productos y servicios que la definen en el múltiple aspecto de empresa
                                    constructora, fabricante, distribuidora y prestadora de servicios.</font>
                            </p>
                            <p class="Standard"
                                style="text-align:justify;text-justify:inter-ideograph;line-height: 100%">
                                <font face="Calibri" size="2" color="#000000">
                                    Nos hemos desarrollado en el mercado electromecánico con una extensa
                                    trayectoria de sucesivas etapas de crecimiento y consolidación,
                                    evolucionando en el ámbito nacional, proyectándonos al internacional con
                                    eficaz desempeño, para satisfacer íntegramente las necesidades de
                                    nuestros clientes en un marco global altamente competitivo.</font>
                            </p>
                            <p class="Standard"
                                style="text-align:justify;text-justify:inter-ideograph;line-height: 100%">
                                <font face="Calibri" size="2" color="#000000">
                                    Somos una empresa que provee servicios, equipos y productos de calidad,
                                    recurriendo para ello a sus recursos humanos altamente capacitados,
                                    potenciado con una infraestructura ágil y moderna, dotada de la más
                                    avanzada tecnología disponible.</font>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td style="background: #009366">
                            <p style="margin-top: 0; margin-bottom: 0" align="center">
                                <font face="Calibri" size="2" color="#ffffff"><b>CERTIFICACIONES</b></font>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <p class="Standard" style="text-align:justify;text-justify:inter-ideograph;line-height: 100%">
                            <font face="Calibri" size="2" color="#000000">
                                Electroingeniería ICS SA cuenta con la certificación de su Sistema de Gestión Integrado
                                (SGI)
                                conforme a las siguientes normas:
                            </font>
                        </p>
                        <p class="Standard" style="line-height: 100%">
                            <font face="Calibri" size="2" color="#000000">
                                • RI 9000-745 (Gestión de la Calidad)
                            </font>
                        </p>
                        <p class="Standard" style="line-height: 100%">
                            <font face="Calibri" size="2" color="#000000">
                                • RI 14000-073 (Gestión Ambiental)
                            </font>
                        </p>
                        <p class="Standard" style="line-height: 100%">
                            <font face="Calibri" size="2" color="#000000">
                                • RI 45000-0104 (Gestión SST - Seguridad y Salud en el Trabajo)
                            </font>
                        </p>
                        <p>
                            <img border="0" src="../../../../public/images/certificados.png" width="200" height="100">
                        </p>
                    </tr>
                    <tr>
                        <td style="background: #009366">
                            <p style="margin-top: 0; margin-bottom: 0" align="center">
                                <font face="Calibri" size="2" color="#ffffff"><b>SERVICIO DE POSVENTA</b></font>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p class="Standard"
                                style="text-align:justify;text-justify:inter-ideograph;line-height: 100%">
                                <font face="Calibri" size="2" color="#000000">
                                    Como parte de nuestra filosofía de trabajo, comprometida con la calidad y la mejora
                                    continua
                                    de
                                    nuestros productos y servicios, contamos con un Servicio Posventa (SPV) para dar
                                    respuesta a
                                    las
                                    necesidades de nuestros clientes.
                                </font>
                            </p>
                            <p class="Standard"
                                style="text-align:justify;text-justify:inter-ideograph;line-height: 100%">
                                <font face="Calibri" size="2" color="#000000">
                                    Ante cualquier consulta:

                                </font>
                            </p>
                            <p>
                                <img border="0" src="../../../../public/images/mail.png" width="30"> Escríbanos un mail
                                a
                                spv@icssa.com.ar
                            </p>
                            <p>
                                <img border="0" src="../../../../public/images/tel.png" width="30"> Comuníquese al
                                teléfono
                                (0351)
                                4144200
                            </p>
                        </td>
                    </tr>
                    <div class="html2pdf__page-break"></div>
                    <tr>
                        <td height="4"></td>
                    </tr>
                    <tr>
                        <td><img border="0" src="../../../../public/images/encabezado.jpg" width="750"></td>
                    </tr>
                    <tr>
                        <td style="background: #009366">
                            <p style="margin-top: 0; margin-bottom: 0" align="center">
                                <font face="Calibri" size="2" color="#ffffff"><b>NUESTROS PRODUCTOS</b></font>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <img border="0" src="../../../../public/images/productos.png" width="750">
                            </p>
                        </td>
                    </tr>
                    <div class="html2pdf__page-break"></div>
                    <tr>
                        <td height="4"></td>
                    </tr>
                    <tr>
                        <td><img border="0" src="../../../../public/images/encabezado.jpg" width="750"></td>
                    </tr>
                    <tr>
                        <td style="background: #009366">
                            <p style="margin-top: 0; margin-bottom: 0" align="center">
                                <font face="Calibri" size="2" color="#ffffff"><b>OFERTA COMERCIAL</b></font>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p class="Standard"
                                style="text-align:justify;text-justify:inter-ideograph;line-height: 100%">
                                <font face="Calibri" size="2" color="#000000">
                                    De nuestra mayor consideración:
                                </font>
                            </p>
                            <p class="Standard"
                                style="text-align:justify;text-justify:inter-ideograph;margin-left: 30pt;line-height: 100%">

                                <font face="Calibri" size="2" color="#000000">
                                    Nos dirigimos a Uds. a los fines de hacerles llegar la siguiente oferta, de acuerdo
                                    a
                                    las
                                    condiciones generales de comercialización adjuntas al final de la presente.

                                </font>

                            </p>
                            <table border="1" width="100%" bordercolorlight="#000000" bordercolordark="#000000"
                                cellspacing="1">
                                <tr>
                                    <td width="10%" align="center">
                                        <b>
                                            <font face="Calibri" size="2" color="#000000">Item</font>
                                        </b>
                                    </td>
                                    <td width="10%" align="center"><b>
                                            <font face="Calibri" size="2" color="#000000">
                                                Cantidad</font>
                                        </b></td>
                                    <td width="50%" align="center"><b>
                                            <font face="Calibri" size="2" color="#000000">
                                                Descripción</font>
                                        </b></td>
                                    <td width="15%" align="center"><b>
                                            <font face="Calibri" size="2" color="#000000">
                                                Unitario</font>
                                        </b></td>
                                    <td width="15%" align="center"><b>
                                            <font face="Calibri" size="2" color="#000000">
                                                Total</font>
                                        </b></td>
                                </tr>
                                <tr>
                                    <td width="10%" align="center">
                                        <font face="Calibri" size="2" color="#000000">{{ item }}</font>
                                    </td>
                                    <td width="10%" align="center">
                                        <font face="Calibri" size="2" color="#000000">{{ cantidad }}</font>
                                    </td>
                                    <td width="50%">
                                        <font face="Calibri" size="2" color="#000000">{{ descrip }}</font>
                                    </td>
                                    <td width="15%" align="center">
                                        <font face="Calibri" size="2" color="#000000">U$S {{ costo }}</font>
                                    </td>
                                    <td width="15%" align="center">
                                        <font face="Calibri" size="2" color="#000000">U$S {{ costo }}</font>
                                    </td>
                                </tr>
                            </table>

                            <p class="Standard"
                                style="text-align:justify;text-justify:inter-ideograph;margin-left: 30pt;line-height: 100%">

                                <font face="Calibri" size="2" color="#000000">
                                    Son: {{ totalpresupuesto }} + IVA
                                </font>

                            </p>
                            <p class="Standard"
                                style="text-align:justify;text-justify:inter-ideograph;margin-left: 30pt;line-height: 100%">

                                <font face="Calibri" size="2" color="#000000">
                                    Sin otro particular, esperamos que nuestra propuesta sea de su agrado y
                                    conveniencia,
                                    quedamos
                                    a entera disposición para atender sus consultas y saludamos atentamente.
                                </font>
                            </p>
                            <p align="center">
                                <img border="0" src="../../../../public/images/firmamarcelo.png" width="70">
                            </p>
                            <p align="center">
                                <font face="Calibri" size="1" color="#000000">Marcelo Battaglino</font>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td style="background: #009366">
                            <p style="margin-top: 0; margin-bottom: 0" align="center">
                                <font face="Calibri" size="2" color="#ffffff"><b>DIAGNÓSTICO</b></font>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p class="Standard"
                                style="text-align:justify;text-justify:inter-ideograph;line-height: 100%">
                                <font face="Calibri" size="2" color="#000000">
                                    <div class="multi-line">
                                        {{ diagnostico }}
                                    </div>
                                </font>
                            </p>
                        </td>
                    </tr>
                    <div class="html2pdf__page-break"></div>
                    <tr>
                        <td height="6"></td>
                    </tr>
                    <tr>
                        <td><img border="0" src="../../../../public/images/encabezado.jpg" width="750"></td>
                    </tr>
                    <tr>
                        <td style="background: #009366">
                            <p style="margin-top: 0; margin-bottom: 0" align="center">
                                <font face="Calibri" size="2" color="#ffffff"><b>CONDICIONES DE VENTA</b></font>
                            </p>
                        </td>
                    </tr>
                    <div v-for="(item, index) in titulos" :key="index">
                        <tr>
                            <td style="background: #D9D9D9">
                                <p style="margin-top: 0; margin-bottom: 0">
                                    <font face="Calibri" size="2" color="#009366"><b>{{ index + 1 }}-{{ item }}</b>
                                    </font>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <div v-for="j in condiciones.length" :key="j">
                                <td v-if="condiciones[j - 1].titulo == item">
                                    <p class="Standard"
                                        style="text-align:justify;text-justify:inter-ideograph;line-height: 100%">
                                        <font face="Calibri" size="2" color="#000000">
                                            <b>{{ condiciones[j - 1].letra }}) <u>{{ condiciones[j - 1].subtitulo
                                            }}:</u></b>
                                            <div class="multi-line">{{ condiciones[j - 1].texto }}</div>
                                        </font>
                                    </p>
                                </td>
                            </div>
                        </tr>
                        <div v-if="(index + 1) % 2 == 0 && (index + 1) < titulos.size" class="html2pdf__page-break">
                        </div>
                        <tr v-if="(index + 1) % 2 == 0 && (index + 1) < titulos.size">
                            <td height="8"></td>
                        </tr>
                        <tr v-if="(index + 1) % 2 == 0 && (index + 1) < titulos.size">
                            <td><img border="0" src="../../../../public/images/encabezado.jpg" width="750"></td>
                        </tr>
                    </div>
                    <tr>
                        <td height="100">-</td>
                    </tr>
                    <tr>
                        <td height="100">-</td>
                    </tr>
                    <tr>
                        <td height="100">-</td>
                    </tr>
                    <tr>
                        <td height="100">-</td>
                    </tr>
                </table>
            </div>
        </v-card>
    </v-dialog>
</template>
<style scoped>
.multi-line {
    white-space: pre-line;
}
</style>
<script>
import moment from "moment";
import axios from "../../../../src/axios-auth";
import html2pdf from 'html2pdf.js'
export default {
    data: (vm) => ({
        // codgral: "1100",
        // cliente: "PRUEBA",
        usuario: "",
        valid: false,
        validcalcular: false,
        lazy: false,
        requiredRules: [(v) => !!v || "Dato obligatorio"],
        nomcodigo: [],
        contacto: "",
        mailcontacto: "",
        tel: "",
        direccion: "",
        respcom: "",
        presupuesto: "",
        descripcion: "",
        beneficio: 0,
        gastosgrales: 0,
        iiggcba: 0,
        iiggprov: 0,
        impcheque: 0,
        comind: 0,
        sellado: 0,
        financiero: 0,
        poliza: 0,
        otros: 0,
        cambio: 1,
        total: "",
        serie1: "",
        serie2: "",
        serie3: "",
        serie4: "",
        serie5: "",
        serie6: "",
        cantidad: "1",
        costo: "",
        item: "1",
        descrip: "",
        listadoC: [],
        diagnostico: "",
        referencia: "",
        fecha: moment().format("DD/MM/YYYY"),
        requiredRules: [(v) => !!v || "Dato obligatorio"],
        estado: "",
        totalpresupuesto: "",
        condiciones: [],
        titulos: [],
        indice: [],
    }),
    props: ["visible", "codgral", "cliente"],
    computed: {
        show: {
            get() {
                //this.mostrar = true;

                //this.respcom = this.$store.state.nombre.toString().trim();
                this.cargarPresupuesto();
                //this.descrip = "Por la reparación de " + this.referencia + " bajo SPV N° " + this.codgral
                console.log("visible " + this.visible)
                return this.visible;

            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    //this.$refs.form.resetValidation();
                    document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },
    },

    methods: {
        vaciarModels() {
            this.titulos = [];
            this.indice = [];
        },
        exportToPDF() {
            html2pdf(document.getElementById("pdfpresupuesto"), {
                margin: 1,
                filename: "i-was-html.pdf",
            });
        },
        PDF() {
            var element = document.getElementById('pdfpresupuesto');
            var opt = {
                margin: [0.2, 0.2, 0.2, 0.2],
                filename: this.presupuesto + this.cliente + ".pdf",
                image: { type: 'jpeg', quality: 1 },
                pagebreak: { mode: ['tr', 'css', 'legacy'] },
                html2canvas: { scale: 2 },
                jsPDF: { unit: 'in', format: 'A4', orientation: 'portrait' }
            };

            html2pdf().from(element).set(opt).save();
            // html2pdf().from(element).set(opt).toPdf().get('pdf').then(function (pdf) {
            //     window.open(pdf.output('bloburl'), '_blank');
            // });
        },

        cargarPresupuesto() {
            const codgral = this.codgral;
            //const codgral = "1100";
            let self = this;
            axios
                .get("/App/CargarPresupuesto?", {
                    params: {
                        codgral: codgral,
                    },
                })
                .then((response) => {
                    //self.cliente = response.data.cliente;
                    self.respcom = response.data.respCom;
                    self.presupuesto = response.data.presupuesto;
                    self.contacto = response.data.contacto;
                    self.referencia = response.data.referencia;
                    self.tel = response.data.tel;
                    self.mailcontacto = response.data.mailcontacto;
                    self.direccion = response.data.direccion;
                    self.diagnostico = response.data.diagnostico;
                    self.descrip = response.data.descrip;
                    self.condiciones = response.data.condiciones;
                    if (response.data.costo != null) {
                        self.costo = response.data.costo;
                    }
                    self.titulos = new Set(response.data.condiciones.map(item => item.titulo));
                    self.indice = new Set(response.data.condiciones.map(item => item.item));
                    console.log(self.titulos)
                    console.log("cantidad " + self.titulos.size)
                })
                .catch((error) => {
                    self.nomcodigo = [];
                    console.log(error);
                });
            // this.calculartotal();
            console.log(convertir.NumerosALetras(self.costo).replace("Pesos", ""));
            // this.totalpresupesto = convertir.NumerosALetras(self.costo).replace("Pesos", "");
            this.$nextTick(() => { this.totalpresupuesto = convertir.NumerosALetras(self.costo).replace("Pesos", "Dólares con").replace("/100 M.N", " centavos"); })
            //this.presupuesto = convertir.NumerosALetras(self.costo).replace("Pesos", "");
            //console.log("cantidad " + self.titulos.length)
        },
    }
};
</script>
